import { render, staticRenderFns } from "./Creativity.vue?vue&type=template&id=1caadd6c&scoped=true&"
import script from "./Creativity.vue?vue&type=script&lang=ts&"
export * from "./Creativity.vue?vue&type=script&lang=ts&"
import style0 from "./Creativity.vue?vue&type=style&index=0&id=1caadd6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caadd6c",
  null
  
)

export default component.exports